"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _material = require("@mui/material");
var _theme = _interopRequireDefault(require("../../theme"));
const Separator = props => {
  return /*#__PURE__*/_react.default.createElement(_material.Box, {
    sx: {
      margin: _theme.default.spacing(0, 2),
      width: '1px',
      height: props.height || '32px',
      backgroundColor: props.color || _theme.default.palette.TwClrBrdrTertiary
    }
  });
};
var _default = exports.default = Separator;